exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".country_presentt{stroke-width:1px;fill:#3a9af3!important;transition:all 1s ease-out;z-index:2;left:0;top:0}.country_presentt:hover{cursor:pointer}.country_presentttt{stroke-width:1px;fill:#9aceff;transition:all 1s ease-out;z-index:2;left:0;top:0}.country_presentttt:hover{cursor:pointer}", ""]);

// exports
